import {
  //
  FETCH_ASSIGNED_ROOMS,
  FETCH_ASSIGNED_ROOMS_FAILURE,
  FETCH_ASSIGNED_ROOMS_SUCCESS,
  //
  GET_VIEW_DATA,
  GET_VIEW_DATA_FAILURE,
  GET_VIEW_DATA_SUCCESS,
  //
  ADD_ASSIGNED_ROOM,
  ADD_ASSIGNED_ROOM_FAILURE,
  ADD_ASSIGNED_ROOM_SUCCESS,

  //
  EDIT_ASSIGNED_ROOM,
  EDIT_ASSIGNED_ROOM_FAILURE,
  EDIT_ASSIGNED_ROOM_SUCCESS,
  //
  DELETE_ASSIGNED_ROOMS,
  DELETE_ASSIGNED_ROOMS_FAILURE,
  DELETE_ASSIGNED_ROOMS_SUCCESS,
  //
  OPEN_ASSIGNED_ROOMS_MODAL,
  CLOSE_ASSIGNED_ROOMS_MODAL,
} from "./constants";

// List
export const fetchAssignedRoom = (payload) => ({
  type: FETCH_ASSIGNED_ROOMS,
  payload,
});
export const fetchAssignedRoomSuccess = (payload) => ({
  type: FETCH_ASSIGNED_ROOMS_SUCCESS,
  payload,
});
export const fetchAssignedRoomFailure = (payload) => ({
  type: FETCH_ASSIGNED_ROOMS_FAILURE,
  payload,
});
// View
export const getViewData = (payload) => ({
  type: GET_VIEW_DATA,
  payload,
});
export const getViewDataSuccess = (payload) => ({
  type: GET_VIEW_DATA_SUCCESS,
  payload,
});
export const getViewDataFailure = (payload) => ({
  type: GET_VIEW_DATA_FAILURE,
  payload,
});
// ADD
export const assignRoom = (payload, onSuccess) => ({
  type: ADD_ASSIGNED_ROOM,
  payload,
  onSuccess,
});
export const assignRoomSuccess = (payload) => ({
  type: ADD_ASSIGNED_ROOM_SUCCESS,
  payload,
});
export const assignRoomFailure = (payload) => ({
  type: ADD_ASSIGNED_ROOM_FAILURE,
  payload,
});
// EDIT
export const editAssignRoom = (payload) => ({
  type: EDIT_ASSIGNED_ROOM,
  payload,
});
export const editAssignRoomSuccess = (payload) => ({
  type: EDIT_ASSIGNED_ROOM_SUCCESS,
  payload,
});
export const editAssignRoomFailure = (payload) => ({
  type: EDIT_ASSIGNED_ROOM_FAILURE,
  payload,
});
// DELETE
export const deleteAssignedRoom = (payload) => ({
  type: DELETE_ASSIGNED_ROOMS,
  payload,
});
export const deleteAssignedRoomSuccess = (payload) => ({
  type: DELETE_ASSIGNED_ROOMS_SUCCESS,
  payload,
});
export const deleteAssignedRoomFailure = (payload) => ({
  type: DELETE_ASSIGNED_ROOMS_FAILURE,
  payload,
});

export const openRoomModal = (payload) => ({
  type: OPEN_ASSIGNED_ROOMS_MODAL,
  payload,
});
export const closeRoomModal = (payload) => ({
  type: CLOSE_ASSIGNED_ROOMS_MODAL,
  payload,
});

/** Open the reusable care-room manage modal (assign | transfer | checkout). */
export const openAssignCareRoomModal = (payload = {}) => ({
  type: OPEN_ASSIGNED_ROOMS_MODAL,
  payload: {
    open: true,
    mode: payload.mode ?? "assign",
    residentId: payload.residentId ?? payload.resident_id ?? null,
    locationId: payload.locationId ?? payload.location_id ?? null,
    currentRoom: payload.currentRoom ?? payload.current_room ?? null,
    ...payload,
  },
});

export const openTransferCareRoomModal = (payload = {}) =>
  openAssignCareRoomModal({ ...payload, mode: "transfer" });

export const openCheckoutCareRoomModal = (payload = {}) =>
  openAssignCareRoomModal({ ...payload, mode: "checkout" });

export const closeAssignCareRoomModal = () => ({
  type: CLOSE_ASSIGNED_ROOMS_MODAL,
});
